export default "__VITE_ASSET__d886a446__"